import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AuthenticationStore } from '../permission/services/authentication.store';
import { SpinnerService } from '../shared/spinner.service';

@Injectable()
export class AppAuthHttpService {

  constructor(
    private http: AuthHttp,
    private authenticationStore: AuthenticationStore,
    private spinnerService: SpinnerService
  ) { }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.get(url, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.post(url, body, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.put(url, body, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.delete(url, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  private refreshTokenFromResponse(response: Response) {
    const token = response.headers.get('Authorization');
    this.authenticationStore.refreshToken(token);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/http/app.auth.http.service.ts